import { keepPreviousData, queryOptions, useQuery } from "@tanstack/react-query"
import { GET } from "@/api/client"
import type { FinancialsCustomersParams, FinancialsWindow } from "@/api/types"

export function financialsSummaryOptions(window: FinancialsWindow) {
	return queryOptions({
		queryKey: ["finance", "financials", "summary", window],
		queryFn: () =>
			GET("/api/v1/finance/financials/summary", {
				params: { query: { window } },
			}),
	})
}

export function useFinancialsSummary(window: FinancialsWindow) {
	return useQuery(financialsSummaryOptions(window))
}

export function financialsSeriesOptions(window: FinancialsWindow) {
	return queryOptions({
		queryKey: ["finance", "financials", "series", window],
		queryFn: () =>
			GET("/api/v1/finance/financials/series", {
				params: { query: { window } },
			}),
		placeholderData: keepPreviousData,
	})
}

export function useFinancialsSeries(window: FinancialsWindow) {
	return useQuery(financialsSeriesOptions(window))
}

interface CustomersParams {
	page: number
	pageSize: number
	excludeUnmapped?: boolean
	search?: string
	sortBy?: FinancialsCustomersParams["sortBy"]
	sortDesc?: boolean
	minNetRevenue?: number
	dateFrom?: string
	dateTo?: string
}

export function financialsCustomersOptions(params: CustomersParams) {
	return queryOptions({
		queryKey: ["finance", "financials", "customers", params],
		queryFn: () =>
			GET("/api/v1/finance/financials/customers", {
				params: { query: params },
			}),
		placeholderData: keepPreviousData,
	})
}

export function useFinancialsCustomers(params: CustomersParams) {
	return useQuery(financialsCustomersOptions(params))
}
